import { createEventHook } from '@vueuse/core';
import { ref } from 'vue';

export interface BlockBounds {
	x: number;
	y: number;
	width: number;
	height: number;
	childId: string;
	slotName?: string;
	index?: number;
	/**
	 * In horizontal mode, for example inside an horizontal layout.
	 */
	horizontal?: boolean;
}

export function useBlockEditorBounds() {
	const updateEvent = createEventHook<string | null>();
	const bounds = ref<Map<string, BlockBounds>>(new Map());

	return {
		bounds,
		updateEvent,
	};
}

export type BlockEditorBounds = ReturnType<typeof useBlockEditorBounds>;
